import React, { useState } from "react";

//UI Material
import {
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  TextField,
} from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import ContainedButton from "../basics/ContainedButton";
import ModalWindow from "../Modal";

//Material Icons
import { Comment } from "@mui/icons-material";

export default function AddCommentDrawer({
  open,
  setOpen,
  getData,
  orderNumber,
}) {
  // ==========> Component State <==========
  //State for new comment
  const [comment, setComment] = useState("");
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  // ==========> Component Function <==========
  //Function to add new comment
  const createComment = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/comments/create-comment",
        {
          orderNumber,
          comment,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("Publicado.");
        setModalDescription(`Se ha publicado tu comentario correctamente.`);
      } else {
        setModalText("No se pudo publicar.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo publicar.");
      setModalDescription(
        "Error al publicar el comentario, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setModalOpen(true);
    setIsLoading(false);
    getData();
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12}>
          {typographyForSubtitles("Nuevo comentario", "secondary")}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack alignItems="center">
            {typographyForText("Ingrese su comentario", "bold")}
            <TextField
              multiline
              sx={{ width: "100%" }}
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
              }}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: 4 }}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Stack direction="row" justifyContent="center" spacing={1}>
              <ContainedButton
                text="Cancelar"
                color="error"
                onClick={() => setOpen(false)}
              />
              <ContainedButton
                text="Publicar"
                endIcon={<Comment />}
                variant={comment === "" ? "disabled" : "contained"}
                onClick={() => {
                  createComment();
                }}
              />
            </Stack>
          )}
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
          setOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
